<h1 class="modal__header">Please contact your financial professional</h1>
<div class="modal__text">
  <p>{{ servicingAgent.person.getFullName() }}</p>
  <p>{{ servicingAgent.address.getOneLineValue() }}</p>
  <p>{{ servicingAgent.phone.getFormatted() }}</p>
  <p>
    <a href="mailto:{{ servicingAgent.person.email }}">{{ servicingAgent.person.email }}</a>
  </p>
</div>
<div class="modal__actions">
  <button class="button button--blue button--primary modal__button" (click)="closeModal()">Exit</button>
</div>
